import axios from 'axios'
import {AuthenticationService} from "./authentication.service";
import router from "../router";

/**
 * ApiService
 */
export const ApiService = {
    /**
     * Envoi générique
     * Lève une erreur pour continuer les rejects sur les promises imbriquées
     */
    _send(config) {
        config.url = process.env.VUE_APP_API_BASE_URL + 'api/' + config.url;

        let token = AuthenticationService.getToken();
        if (token) {
            config.headers = {Authorization: 'Bearer ' + token};
        }

        return axios({
            ...config
        }).catch(error => {
            if (error.response && error.response.status === 401) {
                AuthenticationService.clear();
                router.push({name: 'login'});
            }

            throw new Error(error);
        });
    },

    delete(uri, data) {
        return this._send({
            method: 'DELETE',
            url: uri,
            data: data
        });
    },

    get(uri, datas = {}) {
        return this._send({
            method: 'GET',
            url: uri,
            params: datas
        });
    },

    post(uri, data) {
        return this._send({
            method: 'POST',
            url: uri,
            data: data
        });
    },

    postForm(uri, formData, config = {}) {
        return this._send({
            method: 'POST',
            url: uri,
            data: formData,
            ...config
        });
    },

    put(uri, data) {
        return this._send({
            method: 'PUT',
            url: uri,
            data: data
        });
    }
};